module.exports = __webpack_public_path__ + "media/images/CO_twitter-aee82df4.svg";